import clsx from "clsx";

export const ProgressBar: React.FC<
  React.HTMLAttributes<HTMLDivElement> & {progressClass: string}
> = ({progressClass, ...rest}) => {
  return (
    <div
      className="w-40 h-1 overflow-hidden rounded-full bg-indicator"
      role="progressbar"
      {...rest}
    >
      <div
        className={clsx(
          `h-full rounded-full bg-blackout transition-all duration-300 ease-out`,
          progressClass,
        )}
      />
    </div>
  );
};
